export default __webpack_public_path__ + "static/media/gallery_00.48784502.jpg";